import { DatePicker, Select } from "antd";
import { useContext, useEffect, useState } from "react";
import { DebounceSelect } from "../../../../component/DebounceSelect";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import helper from "../../../../helper/helper";
import { IoPagination } from "../../../../helper/pagination";
import { UserUI } from "../../user/entity/user.model";
import { RouteContext } from "../../user/screen/components/route.context";
import { userService } from "../../user/service/user.service";
import { TaskFilter, TaskStatus, TaskUI } from "../entity/task.model";
import { taskService } from "../service/task.service";
import TaskTable from "./component/TaskTable";

function Tasks() {
  const { Option } = Select;
  const { dispatch } = useContext(SpinContext);
  const { state } = useContext(RouteContext);
  const [taskPagination, setTaskPagination] = useState<IoPagination<TaskUI>>({
    totalElements: 1,
    content: [],
  });
  const [taskFilter, setTaskFilter] = useState<TaskFilter>({
    page: 1,
    pageSize: 10,
  });

  useEffect(() => {
    pageChange(taskFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.routeId]);

  const pageChange = (taskFilter: TaskFilter) => {
    dispatch({ type: spinActions.BLOCK });

    if (state.routeId.length > 0) {
      taskFilter.routeId = state.routeId;
    } else {
      taskFilter.routeId = undefined;
    }

    taskService
      .getTasks(taskFilter)
      .then((pagination: IoPagination<TaskUI>) => {
        taskPagination.current = taskFilter.page;
        setTaskPagination(pagination);
        dispatch({ type: spinActions.UNBLOCK });
      })
      .catch(() => {
        dispatch({ type: spinActions.UNBLOCK });
      });
  };

  return (
    <>
      <MPageHeader crumbs={["Даалгаварууд"]} />
      <div className="content">
        <div className="card">
          <div className="card-header">
            <h6 className="card-title">Даалгаварууд</h6>
          </div>
          <div className="card-body">
            <div className="d-flex bd-highlight example-parent mb-2">
              <DebounceSelect<UserUI>
                showSearch
                allowClear
                placeholder="Хайх"
                onChange={(value) => {
                  setTaskFilter({
                    ...taskFilter,
                    username: value?.username,
                  });
                }}
                fetchOptions={(search) => {
                  return userService.getUsers(search, state.routeId);
                }}
                style={{ maxWidth: "calc(100% - 91px)", width: "250px" }}
              />

              <DatePicker
                className="ml-2"
                placeholder="Огноо"
                onChange={(date, dateString) => {
                  setTaskFilter({
                    ...taskFilter,
                    date: dateString,
                  });
                }}
                style={{ width: 200 }}
              />

              <Select
                className="ml-2"
                placeholder="Төрөл сонгох"
                allowClear
                onChange={(value) => {
                  setTaskFilter({
                    ...taskFilter,
                    taskType: value,
                  });
                }}
                style={{ width: 200 }}
              >
                <Option value={"STALL"}>{helper.getTaskType("STALL")}</Option>
                <Option value={"SALES"}>{helper.getTaskType("SALES")}</Option>
              </Select>

              <Select
                className="ml-2"
                placeholder="Төlөв сонгох"
                allowClear
                onChange={(value) => {
                  setTaskFilter({
                    ...taskFilter,
                    status: value,
                  });
                }}
                style={{ width: 200 }}
              >
                <Option value={TaskStatus.NEW}>
                  {helper.getTaskStatus(TaskStatus.NEW)}
                </Option>
                <Option value={TaskStatus.DECLINED}>
                  {helper.getTaskStatus(TaskStatus.DECLINED)}
                </Option>
                <Option value={TaskStatus.APPROVED}>
                  {helper.getTaskStatus(TaskStatus.APPROVED)}
                </Option>
              </Select>

              <button
                type="button"
                className="btn btn-sm btn-primary ml-2"
                onClick={() => {
                  let _taskFilter = {
                    ...taskFilter,
                    page: 1,
                    pageSize: 10,
                  };

                  pageChange(_taskFilter);
                }}
              >
                <i className="icon-search4 mr-2" />
                Хайх
              </button>
            </div>

            <TaskTable
              pagination={taskPagination}
              onChange={(page: number, pageSize: number) => {
                pageChange({ page, pageSize });
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Tasks;
